import React from 'react';
import { getTransferType } from '../../utils';
import { Details, Term } from '../shared';
var TransferSpeedDisplay = function (_a) {
    var fromAccount = _a.fromAccount, toAccount = _a.toAccount, transferSpeed = _a.transferSpeed;
    var transferType = getTransferType(fromAccount, toAccount);
    if (transferType === 'INTERNAL')
        return (React.createElement(React.Fragment, null,
            React.createElement(Term, null, "Transfer speed"),
            React.createElement(Details, null, "Instant")));
    if (transferType === 'EXTERNAL')
        return (React.createElement(React.Fragment, null,
            React.createElement(Term, null, "Transfer speed"),
            React.createElement(Details, null, transferSpeed === 'Next Day' ? '1 business day' : '3 business days')));
    return null;
};
export default TransferSpeedDisplay;
//# sourceMappingURL=Display.js.map